import React, { useContext, useEffect, useState } from "react";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import lifeinsurancelic from "../../assets/life-insurance-lic--250x250.svg";
import BackButton from "../../components/common/BackButton";
import { useNotificationActionsContext } from "../../components/notificationModal/useModal";
import { Context } from "../../services/apiContext";
import "./css/IPOSummary.css";
import SummaryTable from "./SummaryTable";


const IPOSummary = ({
  nextStep,
  prevStep,
  bidingDetail:bidDetails,
  prevPage,
  goToPage,
  summaryData,
  ...props
}) => {
  const stepBack = () => {
    // goToPage(prevPage, summaryData.summarydataname.BidingDetails? summaryData.summarydataname: {}, summaryData.summarydataname.BidingDetails?'gobacksameIPO': true);
    goToPage(prevPage, summaryData.summarydataname.BidingDetails? summaryData.summarydataname: {}, 'gobacksameIPO');
  };

  useEffect(() => {
    getIPOdetails();
  }, []);
  const [ipoDetails, setIpoDetails] = useState({});

  console.log(summaryData)
  console.log(",.,.,...,..,.,.,.<><><>>>><")
  //new APIS
  const contextapi = useContext(Context);
  const setNotifi = useNotificationActionsContext();
  const getIPOdetails = async () => {
    var useData = contextapi.getSession("userData").user_key;

    var postData = {
      symbol: summaryData.summarydataname.symbol?summaryData.summarydataname.symbol: summaryData.summarydataname.Symbol,
      user_key: useData,
    };
    var url = "/nse/getipodetails";
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === "00") {
          setIpoDetails(res[0].IPODetails[0]);
          setstep(2);
        } else {
          setNotifi({ val: true, msg: res[0].status_desc });
        }
      })
      .catch((error) => {
         console.log(error);
      });
  };

  const [step, setstep] = useState(1);
  const runSummaryTable = () => {
    switch (step) {
      case 1:
        return <></>;
      case 2:
        return (
          <SummaryTable
            nextStep={nextStep}
            prevStep={prevStep}
            ipoDetail={ipoDetails}
            summaryData={summaryData}
          />
        );
    }
  };

  const highestBid = bidDetails?.reduce(function (prev, current) {
      return ((+prev.cart.quantity * +prev.cart.price) > (+current.cart.quantity * +current.cart.price)) ? prev : current
  })
  const hideTotals = !props.ipoDetails?.Indetails

  const totalBiddingAmount = !hideTotals &&  Number(highestBid.cart.quantity) * Number(highestBid.cart.price)
  const totalShares = !hideTotals && bidDetails?.reduce(function (total, current) {
      return total + Number(current.cart.quantity) 
  },0)


  return (
    <div>
      <div className="col-lg-12 col-md-12 col-12 addmargin">
        <h5 className="transactionheader">IPO SUMMARY</h5>
        <p className="transactionheader_desc">
          The following content shows the summary of an IPO
        </p>

        <BackButton />
      </div>

      <div className="IPOCard-List">
        <div className="row makerel">
        {!hideTotals && 
          <div className="graphTopflex">
            <div className="indivgraph">
              <CircularProgressbar
                value="90"
                // minValue={30,384}
                // maxValue={60.384}
                text={`/`}
                className="ProgressBar"
                styles={buildStyles({
                  // rotation:0.25,
                  pathTransitionDuration: 1,

                  pathColor: "#11269229",
                  trailColor: "#FDFDFE",
                })}
              />
              <div className="graphInnerbox">
                <p className="labelingrapgsummary">Total Share</p>
                <p className="valueingraphsummary">{totalShares}</p>
              </div>
            </div>

            <div className="indivgraph">
              <CircularProgressbar
                value="90"
                // minValue={30,384}
                // maxValue={60.384}
                text={`/`}
                className="ProgressBar"
                styles={buildStyles({
                  // rotation:0.25,
                  pathTransitionDuration: 1,
                  pathColor: "#3A57E8",
                  trailColor: "#FDFDFE",
                })}
              />
              <div className="graphInnerbox">
                <p className="labelingrapgsummary">Total Investment (₹)</p>
                <p className="valueingraphsummary">{totalBiddingAmount}</p>
              </div>
            </div>
          </div>
        }

          <div className="IPO_list_IndividuaCard">
            <div className="row ">
              <div className="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12 paddingzeroipodetails">
                <div className="newFlexItems">
                  <div className="innerImageDiveView_new cursorPointer">
                    {ipoDetails.ipotime == "new" && (
                      <div className="postionbadge">
                        <div className="badgearrow">New</div>
                      </div>
                    )}

                    <img
                      src={lifeinsurancelic}
                      alt="lifeinsu"
                      className="IPOImg"
                    />
                  </div>

                  <div className="makeitmiddlealign_new">
                    <p className="ipoNameValue">{ipoDetails.Name}</p>
                    {/* <p className="ipodateRange">{ipoDetails && ipoDetails.BiddingStartDate.split(",")[0]}-
                      {ipoDetails && ipoDetails.BiddingEndDate.split(",")[0]}</p> */}
                  </div>

                  <div className="makeitmiddlealignmore_new">
                    {/* <div className={`ipostatus algincenter mobltop ${ipoDetails.status === "Open" ? 'clrgreen' : (ipoDetails.status === "Closed") ? 'clrorange' : (ipoDetails.status === "Upcoming") ? 'lightred' : ''}`}>
                                            {ipoDetails.status}
                                        </div> */}
                    <div
                      className={`ipostatus algincenter mobltop ${
                        ipoDetails.OpenStatus === "O"
                          ? "clrgreen"
                          : ipoDetails.OpenStatus === "C"
                          ? "clrorange"
                          : ipoDetails.OpenStatus === "U"
                          ? "lightred"
                          : ""
                      }`}
                    >
                      {ipoDetails.OpenStatus === "O"
                        ? "Open"
                        : ipoDetails.OpenStatus === "C"
                        ? "Closed"
                        : ipoDetails.OpenStatus === "U"
                        ? "Upcoming"
                        : ""}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12 paddingzeroipodetails">
                <div className="newFlexItems">
                  <div className="  algincenter secondpartFlexfirst_summary">
                    <p className="ipoNameValue">Lot Size</p>
                    <p className="ipodateRange">{ipoDetails.LotSize}</p>
                  </div>

                  <div className=" algincenter  secondpartFlexfirst_summary">
                    <p className="ipoNameValue">Price Range</p>
                    <p className="ipodateRange">
                      {ipoDetails.MinPrice}-{ipoDetails.MaxPrice}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {runSummaryTable()}
        </div>
      </div>
    </div>
  );
};

export default IPOSummary;
